export const TESTIMONIAL_EVENTS = {
  BUTTON: "select_button",
  TESTIMONIALS: "testimonials",
};
